/** Initial user roles for Cannery Laundry Hub. */
export const ROLES = ['ADMIN', 'WASHING_EMPLOYEE', 'FOLDING_EMPLOYEE'] as const;

export type Role = (typeof ROLES)[number];

export const ROLE_LABELS: Record<Role, string> = {
  ADMIN: 'Admin',
  WASHING_EMPLOYEE: 'Washing Employee',
  FOLDING_EMPLOYEE: 'Folding Employee',
};

export function isRole(value: unknown): value is Role {
  return typeof value === 'string' && (ROLES as readonly string[]).includes(value);
}

/** True when the role is an operational (non-admin) employee account. */
export function isEmployeeRole(role: Role): boolean {
  return role === 'WASHING_EMPLOYEE' || role === 'FOLDING_EMPLOYEE';
}
